export enum DeckSlot {
  HEAT_MAP = "heatMap",
  USER_LOCATION_HEAT_MAP = "userLocationHeatMap",
  DEMOGRAPHY = "demography",
  TERRITORIES = "territories",
  RULER = "ruler",
  PINS = "pins",
}

export enum DeckOverlayType {
  LOWER = "lower",
  TERRITORIES = "territories",
  UPPER = "upper",
}

// Bottom first
export const SLOT_ORDER: readonly DeckSlot[] = [
  DeckSlot.HEAT_MAP,
  DeckSlot.USER_LOCATION_HEAT_MAP,
  DeckSlot.DEMOGRAPHY,
  DeckSlot.TERRITORIES,
  DeckSlot.RULER,
  DeckSlot.PINS,
];

export const SLOT_OVERLAY: Record<DeckSlot, DeckOverlayType> = {
  [DeckSlot.DEMOGRAPHY]: DeckOverlayType.LOWER,
  [DeckSlot.HEAT_MAP]: DeckOverlayType.LOWER,
  [DeckSlot.PINS]: DeckOverlayType.UPPER,
  [DeckSlot.RULER]: DeckOverlayType.UPPER,
  [DeckSlot.TERRITORIES]: DeckOverlayType.TERRITORIES,
  [DeckSlot.USER_LOCATION_HEAT_MAP]: DeckOverlayType.LOWER,
};
